import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTagManager from 'vue-tag-manager'
import './registerServiceWorker'
import './assets/style/style.css'
import {
  NavBar,
  Tabs,
  Tab,
  Icon,
  List,
  Locale,
  TabbarItem,
  Button,
  Cell,
  CellGroup,
  Field,
  Actionsheet,
  Col,
  Row,
  Steps,
  Step,
  Toast,
  PullRefresh
} from 'vant'
import 'vant/lib/index.css'
import vueMoment from 'vue-moment'
import urlHelper from './urlHelper'
import axios from 'axios'
import enUS from 'vant/lib/locale/lang/en-US'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Locale.use('en-US', enUS)

Vue.use(List)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Actionsheet)
Vue.use(vueMoment)
Vue.use(Col)
Vue.use(Row)
Vue.use(Steps)
Vue.use(Step)
Vue.use(PullRefresh)
Vue.use(Toast)
Vue.use(urlHelper)

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(VueTagManager, {
  gtmId: 'GTM-KKLQKF'
})

// or
const messages = {
  en: require('./assets/langs/en.json'), // 英
  es: require('./assets/langs/es.json'), // 西班牙
  fr: require('./assets/langs/fr.json'), // 法
  it: require('./assets/langs/it.json'), // 意
  de: require('./assets/langs/de.json'), // 德
  pt: require('./assets/langs/pt.json'), // 巴西
  gr: require('./assets/langs/gr.json'), // 希腊
  ru: require('./assets/langs/ru.json'), // 俄
  ja: require('./assets/langs/ja.json'), // 日
  da: require('./assets/langs/da.json'), // 丹麦
  fi: require('./assets/langs/fi.json'), // 芬兰
  no: require('./assets/langs/no.json'), // 挪威
  po: require('./assets/langs/po.json'), // 波兰
  sv: require('./assets/langs/sv.json'), // 瑞典
  is: require('./assets/langs/is.json'), // 冰岛
  nl: require('./assets/langs/nl.json') // 荷兰
}

let lang = 'en'
const langReg = new RegExp('(^|&)lang=([^&]*)(&|$)', 'i')
// const codLangReg = new RegExp('(^|&)cod_lang=([^&]*)(&|$)', 'i')
const clienIDReg = new RegExp('(^|&)cid=([^&]*)(&|$)', 'i')
const allParmas = window.location.search.substr(1)
const langParam = allParmas.match(langReg)
// const codLangParam = allParmas.match(codLangReg)
const clienIDParam = allParmas.match(clienIDReg)
let tempLang
if (langParam) {
  if (decodeURI(langParam[2]).indexOf('_') !== -1) {
    localStorage.setItem('cod_lang', decodeURI(langParam[2]))
    tempLang = decodeURI(langParam[2]).split('_')
    tempLang = tempLang[0]
  } else {
    localStorage.setItem('cod_lang', '')
    tempLang = decodeURI(langParam[2])
  }
}
// if (codLangParam) {
//   localStorage.setItem('cod_lang', decodeURI(codLangParam[2]))
//   tempLang = decodeURI(codLangParam[2]).split('_')
//   tempLang = tempLang[0]
// }
if (tempLang in messages) {
  lang = tempLang
}

if (clienIDParam) {
  let clienID = decodeURI(clienIDParam[2])
  localStorage.setItem('cid', clienID)
}

localStorage.setItem('lang', lang)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
  silentTranslationWarn: true
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
